import stickybits from "stickybits";

function initStickyBits() {
  stickybits(".js-stickybit");
}

export default initStickyBits;
